/**
 * @fileoverview App Insights API Service
 * @description API service layer for Application Insights timeline feature.
 *              Follows the same pattern as incidentApi.js.
 * @module features/AppInsights/services/appInsightsApi
 */

import { apiClient } from '@/services';

const BASE = '/v1/app-insights';

export const appInsightsApi = {
  /** Health check — verifies credentials are configured */
  health: () => apiClient.get(`${BASE}/health`),

  /** Pre-built overview timeline (requests count, avg duration, failures) */
  getOverview: (params = {}) => apiClient.get(`${BASE}/overview`, params),

  /** Request metrics timeline */
  getRequests: (params = {}) => apiClient.get(`${BASE}/requests`, params),

  /** Exception metrics timeline */
  getExceptions: (params = {}) => apiClient.get(`${BASE}/exceptions`, params),

  /** Dependency metrics timeline */
  getDependencies: (params = {}) => apiClient.get(`${BASE}/dependencies`, params),

  /** Availability metrics timeline */
  getAvailability: (params = {}) => apiClient.get(`${BASE}/availability`, params),

  /** Custom events timeline */
  getEvents: (params = {}) => apiClient.get(`${BASE}/events`, params),

  /** Page view metrics timeline */
  getPageViews: (params = {}) => apiClient.get(`${BASE}/pageviews`, params),

  /** Trace log metrics timeline */
  getTraces: (params = {}) => apiClient.get(`${BASE}/traces`, params),

  /** Execute free-form KQL query */
  executeQuery: (query, timespan) =>
    apiClient.post(`${BASE}/query`, { query, timespan }),

  /** Module usage stats — views, users, time per page */
  getModuleUsage: (params = {}) => apiClient.get(`${BASE}/module-usage`, params),

  /** Module usage over time */
  getModuleUsageTimeline: (params = {}) => apiClient.get(`${BASE}/module-usage/timeline`, params),

  /** User session stats */
  getUserSessions: (params = {}) => apiClient.get(`${BASE}/user-sessions`, params),

  /** Performance heatmap (hour × day-of-week) */
  getPerformanceHeatmap: (params = {}) => apiClient.get(`${BASE}/performance-heatmap`, params),

  /** Dependency map — external services graph */
  getDependencyMap: (params = {}) => apiClient.get(`${BASE}/dependency-map`, params),

  /** Dependency timeline */
  getDependencyTimeline: (params = {}) => apiClient.get(`${BASE}/dependency-map/timeline`, params),

  /** AI chat — natural language question → KQL → results → summary */
  aiChat: (question, history = []) => apiClient.post(`${BASE}/ai-chat`, { question, history }),
};
